// extracted by mini-css-extract-plugin
export var blueGhost = "OIre8U_R0Vg3ZvdI6nme x9iSAtj5t4OADvXFWkGH";
export var blueUnderlined = "x9iSAtj5t4OADvXFWkGH";
export var colourInherit = "WM73YxvuWjdLtVFSsBAu";
export var focusVisible = "ZbZXCULOit264gis6o5t";
export var icon = "jthTyWdbUifkCTb1NJve";
export var root = "OLNorsjt3u5ZVg5sQ_vp";